module.exports = __webpack_public_path__ + "img/icon-chat-failure.6296f0f2.svg";